import { GridApi } from 'ag-grid-community'
import { forEach } from 'lodash'
import { showCustomizeColumnsVar } from '../../../../cache/adv-filtering'

export const handleCloseCustomizeColumns = (
  gridApi: GridApi,
  hiddenColumns?: string[],
  visibleColumns?: string[]
) => {
  showCustomizeColumnsVar(false)
  if (gridApi && hiddenColumns instanceof Array && visibleColumns instanceof Array) {
    const allNewColumns = [...(visibleColumns || []), ...(hiddenColumns || [])]
    // add columns not listed in either visible or hidden but present in grid
    forEach(gridApi.getColumnState(), (item, idx) => {
      if (['searchField'].includes(item.colId || '')) return
      if (
        visibleColumns.indexOf(item.colId || '') === -1 &&
        hiddenColumns.indexOf(item.colId || '') === -1
      )
        allNewColumns.splice(idx, 0, item.colId || '')
    })
    const allColumns = gridApi
      .getColumnState()
      .sort(
        (colA, colB) =>
          allNewColumns.indexOf(colA.colId || '') - allNewColumns.indexOf(colB.colId || '')
      )
    const columns = gridApi.getColumnState()
    allColumns.forEach((col) => {
      const colDef = columns.find((item) => item.colId === col.colId)
      // if (colDef && !colDef.suppressMovable) { // immovable check Handle when we start user preference PBI
      if (colDef) {
        // immovable check
        col.hide = (hiddenColumns || []).includes(col.colId || '')
      }
      if (col.colId === 'searchField') {
        col.hide = true
      }
      if (
        ['calcGuidanceFloorAsyncNetAmount', 'calcGuidanceFloorAsyncPercentage'].includes(col.colId)
      ) {
        col.hide = true
      }
    })
    gridApi.applyColumnState({ state: allColumns, applyOrder: true })
  }
}
